var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "0 0 7 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u533A\\u5757",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.05,2.17603713e-14 C4.0671875,2.17603713e-14 4.08125,0.0140625 4.08125,0.03125 L4.081,2.915 L6.965625,2.915625 C6.9828125,2.915625 6.996875,2.9296875 6.996875,2.946875 L6.996875,4.05 C6.996875,4.0671875 6.9828125,4.08125 6.965625,4.08125 L4.081,4.081 L4.08125,6.965625 C4.08125,6.9828125 4.0671875,6.996875 4.05,6.996875 L2.946875,6.996875 C2.9296875,6.996875 2.915625,6.9828125 2.915625,6.965625 L2.915,4.081 L0.03125,4.08125 C0.0140625,4.08125 2.17603713e-14,4.0671875 2.17603713e-14,4.05 L2.17603713e-14,2.946875 C2.17603713e-14,2.9296875 0.0140625,2.915625 0.03125,2.915625 L2.915,2.915 L2.915625,0.03125 C2.915625,0.0140625 2.9296875,2.17603713e-14 2.946875,2.17603713e-14 L4.05,2.17603713e-14 Z",
    id: "add",
    fill: "#E27279",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e07ef824.svg";
export { ForwardRef as ReactComponent };